import type { FC } from 'react';
import React from 'react';

import { ContentHeaderPresence } from '@confluence/team-presence/entry-points/ContentHeaderPresence.tsx';
import type { ContentHeaderPresenceProps } from '@confluence/team-presence/entry-points/presenceTypes.ts';

type PresenceProps = {
	contentMode: string | undefined;
	isViewMode?: boolean;
} & Omit<ContentHeaderPresenceProps, 'analyticSource'>;

export const Presence: FC<PresenceProps> = ({
	collaborators,
	contentId,
	contentType,
	contentMode,
	isViewMode,
}) => {
	return (
		<ContentHeaderPresence
			collaborators={collaborators}
			contentId={contentId}
			contentType={contentType}
			isViewMode={isViewMode}
			analyticSource={contentMode === 'view' ? 'viewPageScreen' : 'editPageScreen'}
		/>
	);
};
